import { IEnvironment } from '@core/interfaces/common';
import packageJSON from '../../package.json';

export const environment: IEnvironment = {
  production: false,
  appName: 'Centros Capitados',
  version: packageJSON.version,
  API_KEY: 'tdhBWAE1M7fAxQD1nCoztyQNT535vvpbd0YytvFt',
  BASE_URL: 'https://dev.api.capitados.koneksi.com.do',
  fingerprintCaptureUrl: 'http://localhost:5010'
};
